import React from 'react';
import '../CancellationRefund/styles.css';

const PrivacyPolicy = () => {
  const lastUpdated = new Date().toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <h1 className="legal-title">Privacy Policy</h1>
          <p className="legal-updated">Last Updated: {lastUpdated}</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Overview</h2>
            <p>
              Douglas &amp; McCartney respects your privacy. This Privacy Policy explains how we collect, use, store,
              and protect personal information shared through our website, forms, downloadable resources, webinar
              registrations, and related communications.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Information We Collect</h2>
            <p>We may collect information that you voluntarily provide, including:</p>
            <ul>
              <li>Name, email address, and phone number submitted through contact or registration forms</li>
              <li>Business preferences or experience details shared during inquiries or webinar registration</li>
              <li>Information submitted for downloads, callback requests, or event access requests</li>
              <li>Communication history when you contact us through email, phone, or website forms</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Website Analytics &amp; Technical Data</h2>
            <p>
              We may use analytics and tracking tools (such as website analytics tags and campaign parameters) to
              understand traffic sources, website usage patterns, and campaign performance. This may include device,
              browser, page visit, and referral information.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. How We Use Your Information</h2>
            <p>We use collected information for legitimate business purposes, including to:</p>
            <ul>
              <li>Respond to inquiries and contact requests</li>
              <li>Process webinar registrations and ebook download requests</li>
              <li>Share confirmations, event details, and related communication</li>
              <li>Improve website performance, user experience, and content relevance</li>
              <li>Maintain internal records, service quality, and compliance obligations</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Sharing of Information</h2>
            <p>
              We do not sell personal data. We may share data only when reasonably necessary with trusted service
              providers and platforms used for website hosting, analytics, communications, email delivery, scheduling,
              or payment processing, subject to applicable confidentiality and security controls.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Data Retention</h2>
            <p>
              We retain information only for as long as required for inquiry follow-up, service communication,
              compliance, record-keeping, or legitimate business purposes. Retention periods may vary based on the type
              of request, transaction, or applicable legal requirement.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Data Security</h2>
            <p>
              We take reasonable administrative and technical measures to protect information submitted through our
              website. However, no method of internet transmission or electronic storage is completely secure, and we
              cannot guarantee absolute security.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Your Choices</h2>
            <p>
              You may contact us to request correction or deletion of personal information previously shared through the
              website, subject to legal, operational, or record-keeping requirements. You may also choose not to submit
              optional information through forms.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Policy Updates</h2>
            <p>
              We may update this Privacy Policy periodically. Any revised version will be published on this page with an
              updated effective date.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Contact</h2>
            <p>
              If you have questions about this Privacy Policy or how your information is handled, please contact us at:
            </p>
            <p className="contact-info">
              Email:{' '}
              <a href="mailto:partnerships@douglasmccartney.com" className="legal-inline-link">
                partnerships@douglasmccartney.com
              </a>
              <br />
              Phone: +91 95352 98949
            </p>
          </section>
        </div>

        <div className="legal-footer">
          <button onClick={() => window.close()} className="back-button">Close Window</button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
